<div class="flex flex-col w-full h-full bg-gray-100 p-4">
  <div class="bg-white rounded-lg shadow-md p-4 max-h-[calc(100vh-8rem)] overflow-hidden flex flex-col">
    
    <div class="flex-1 overflow-y-auto space-y-3">
      <div class="grid grid-cols-2 gap-2">
        <button 
          (click)="selectPaymentMethod('MONEY')"
          class="p-2 bg-green-600 text-white rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 transition-colors flex items-center justify-center gap-2">
          <span class="text-base">💰</span>
          <div class="flex flex-col items-start">
            <span class="text-xs">Dinheiro</span>
            <span class="text-xs opacity-75">(D)</span>
          </div>
        </button>
        
        <button 
          (click)="selectPaymentMethod('BANK_TRANSFER')"
          class="p-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-teal-500 transition-colors flex items-center justify-center gap-2">
          <span class="text-base">🏦</span>
          <div class="flex flex-col items-start">
            <span class="text-xs">Ted/Doc</span>
            <span class="text-xs opacity-75">(T)</span>
          </div>
        </button>
        
        <button 
          (click)="selectPaymentMethod('PIX')"
          class="p-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors flex items-center justify-center gap-2">
          <span class="text-base">📱</span>
          <div class="flex flex-col items-start">
            <span class="text-xs">PIX</span>
            <span class="text-xs opacity-75">(P)</span>
          </div>
        </button>
        
        <button 
          (click)="selectPaymentMethod('BANK_TRANSFER')"
          class="p-2 bg-cyan-600 text-white rounded-lg hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-cyan-500 transition-colors flex items-center justify-center gap-2">
          <span class="text-base">🏦</span>
          <div class="flex flex-col items-start">
            <span class="text-xs">Depósito</span>
            <span class="text-xs opacity-75">(S)</span>
          </div>
        </button>
        
        <button 
          (click)="selectPaymentMethod('DEBIT_CARD')"
          class="p-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-colors flex items-center justify-center gap-2">
          <span class="text-base">💳</span>
          <div class="flex flex-col items-start">
            <span class="text-xs">Cartão de Débito</span>
            <span class="text-xs opacity-75">(B)</span>
          </div>
        </button>
        
        <button 
          (click)="selectPaymentMethod('CHECK')"
          class="p-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 transition-colors flex items-center justify-center gap-2">
          <span class="text-base">📄</span>
          <div class="flex flex-col items-start">
            <span class="text-xs">Cheque</span>
            <span class="text-xs opacity-75">(E)</span>
          </div>
        </button>
        
        <button 
          (click)="selectPaymentMethod('CREDIT_CARD')"
          class="p-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 transition-colors flex items-center justify-center gap-2">
          <span class="text-base">💳</span>
          <div class="flex flex-col items-start">
            <span class="text-xs">Cartão de Crédito</span>
            <span class="text-xs opacity-75">(C)</span>
          </div>
        </button>
        
        <button 
          (click)="selectPaymentMethod('VOUCHER')"
          class="p-2 bg-pink-600 text-white rounded-lg hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-pink-500 transition-colors flex items-center justify-center gap-2">
          <span class="text-base">🎫</span>
          <div class="flex flex-col items-start">
            <span class="text-xs">Vale</span>
            <span class="text-xs opacity-75">(V)</span>
          </div>
        </button>
        
        <button 
          (click)="selectPaymentMethod('CREDIARIO')"
          class="p-2 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 transition-colors flex items-center justify-center gap-2">
          <span class="text-base">💳</span>
          <div class="flex flex-col items-start">
            <span class="text-xs">Crediário</span>
            <span class="text-xs opacity-75">(O)</span>
          </div>
        </button>
      </div>
    </div>
    
    <div class="mt-3 border-t pt-3 flex-shrink-0">
      <div class="bg-gray-50 p-2 rounded-md">
        <div class="grid grid-cols-2 gap-2">
          <div>
            <label class="text-sm font-medium text-gray-600">Total da Venda:</label>
            <span class="ml-2 text-base font-semibold text-green-600">{{ totalSale | currency:'BRL' }}</span>
          </div>
          <div>
            <label class="text-sm font-medium text-gray-600">Valor Pago:</label>
            <span class="ml-2 text-base font-semibold text-blue-600">{{ totalPaid | currency:'BRL' }}</span>
          </div>
          <div>
            <label class="text-sm font-medium text-gray-600">Restante:</label>
            <span class="ml-2 text-base font-semibold" [ngClass]="remainingAmount > 0 ? 'text-red-600' : 'text-green-600'">
              {{ remainingAmount | currency:'BRL' }}
            </span>
          </div>
          <div>
            <label class="text-sm font-medium text-gray-600">Troco:</label>
            <span class="ml-2 text-base font-semibold text-orange-600">{{ exchange | currency:'BRL' }}</span>
          </div>
        </div>
      </div>
      
      <div class="flex justify-end space-x-4 mt-2">
        <button 
          (click)="cancel()"
          class="px-6 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500">
          Cancelar (ESC)
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Componente de entrada de valor -->
<app-payment-amount-input 
  *ngIf="selectedPaymentMethod" 
  [paymentMethod]="selectedPaymentMethod"
  [maxAmount]="remainingAmount"
  (paymentCompleted)="onPaymentCompleted($event)"
  (cancel)="onPaymentCancel()">
</app-payment-amount-input>
